<script setup lang="ts">
import { ButtonComponent } from '@metapic-apps/shared'
import { computed, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

import { useErrorStore } from '@/stores/error.stores'
import { BoxComponent, FlexComponent, TypographyComponent } from '@/ui-library'

const props = defineProps<{
  handleRetry?: () => void
}>()

const errorStore = useErrorStore()
const router = useRouter()
const currentError = computed(() => errorStore.currentError)

const defaultRetry = () => {
  errorStore.clearError()
  router.go(-1)
}

onUnmounted(() => errorStore.clearError())

const retryPage = props.handleRetry || defaultRetry

const goHome = async () => {
  errorStore.clearError()
  await router.push('/')
}
</script>

<template>
  <FlexComponent direction="column" align="center" justify="center">
    <BoxComponent :p="48" :max-w="600">
      <FlexComponent direction="column" align="center" :gap="24">
        <TypographyComponent variant="headline-medium" text-align="center">
          {{ currentError?.title || 'Something Went Wrong' }}
        </TypographyComponent>
        <TypographyComponent variant="body-large" text-align="center">
          {{ currentError?.message || 'We encountered an unexpected error. Please try again or contact support if the problem persists.' }}
        </TypographyComponent>
        <FlexComponent :gap="16">
          <ButtonComponent v-if="currentError?.showRetryButton" variant="primary" @click="retryPage"> Try Again </ButtonComponent>
          <ButtonComponent
            v-if="currentError?.showHomeButton"
            :variant="currentError?.showRetryButton ? 'outlined' : 'primary'"
            @click="goHome"
          >
            Go to Overview Page
          </ButtonComponent>
        </FlexComponent>
      </FlexComponent>
    </BoxComponent>
  </FlexComponent>
</template>
